module.exports = __webpack_public_path__ + "static/media/survey.9eec62ef.svg";